import { request } from '../utils/request';

export const fetchPathwayScormApprovals = () =>
  request.get('/superadmin/pathway-scorm-approvals');

export const approvePathwayScormApproval = id =>
  request.put(`/superadmin/pathway-scorm-approvals/${id}/approve`);

export const rejectPathwayScormApproval = (id, rejectionReason) =>
  request.put(`/superadmin/pathway-scorm-approvals/${id}/reject`, {
    rejectionReason,
  });
